import axios from "axios";

function getDefaultApiBase() {
  if (typeof window === "undefined") {
    return "http://localhost:5000";
  }

  const host = window.location.hostname;

  if (!host || host === "localhost" || host === "127.0.0.1" || host === "0.0.0.0") {
    return "http://localhost:5000";
  }

  if (/^\d+\.\d+\.\d+\.\d+$/.test(host)) {
    return `http://${host}:5000`;
  }

  return `http://${host}:5000`;
}

// Toggle endpoints by commenting/uncommenting ONE of the lines below.
const BASE_URL = getDefaultApiBase();

// Live/Production
// const BASE_URL = "http://72.61.210.160:5000";

// NOTE: If REACT_APP_API_URL is set in the environment, it will override the manual selection above.
// Additionally, allow a runtime override via localStorage (SUPERADMIN_API_URL) for easier switching.
let runtimeBase = "";
try {
  if (typeof window !== "undefined") {
    runtimeBase = (window.localStorage.getItem("SUPERADMIN_API_URL") || "").trim();
  }
} catch (_) {}

const RAW_BASE = (runtimeBase || process.env.REACT_APP_API_URL || BASE_URL || "").trim();

// Normalize and ensure trailing "/api" so routes like "/superadmin/login" map to backend mount "/api/superadmin/login"
function ensureApiSuffix(url) {
  if (!url) return "/api";
  const withoutTrailing = url.replace(/\/+$/, "");
  return /\/api$/i.test(withoutTrailing) ? withoutTrailing : `${withoutTrailing}/api`;
}

const RESOLVED_BASE_URL = ensureApiSuffix(RAW_BASE);

// Create axios instance
const api = axios.create({
  baseURL: RESOLVED_BASE_URL,
  timeout: 15000,
  headers: {
    "Accept": "application/json",
  },
});

// Basic response/error logging to help diagnose endpoint issues during swaps
if (typeof window !== "undefined") {
  // eslint-disable-next-line no-console
  console.info("eLaba SuperAdmin API base:", RESOLVED_BASE_URL);
}

api.interceptors.response.use(
  (response) => response,
  (error) => {
    // eslint-disable-next-line no-console
    console.error("API request failed:", {
      url: error?.config?.baseURL ? `${error.config.baseURL}${error.config.url}` : error?.config?.url,
      method: error?.config?.method,
      message: error?.message,
      status: error?.response?.status,
      data: error?.response?.data,
    });
    return Promise.reject(error);
  }
);

export default api;
